import app from 'flarum/forum/app';

/** Community projects on the website: shared by the list, a project's page, the form and the invitation/follow links. */
export const LIST_ROUTE = 'voucha-community.projects';
export const NEW_ROUTE = 'voucha-community.projects.new';
export const JOIN_ROUTE = 'voucha-community.projects.join';
export const FOLLOW_ROUTE = 'voucha-community.projects.follow';
export const PAGE_ROUTE = 'voucha-community.project';

/** Community projects are coming soon: only admins (testing) can use them until the server opens them */
export const communityOpen = () => !!app.forum.attribute('vouchaCommunityProjects');
export const api = path => app.forum.attribute('apiUrl') + '/voucha-community' + path;
const routeName = () => {
  try {
    return app.current && app.current.get('routeName') || '';
  } catch (e) {
    return '';
  }
};
const path = () => {
  try {
    return (m.route.get() || '').split('?')[0];
  } catch (e) {
    return '';
  }
};
export const onList = () => routeName() === LIST_ROUTE || path() === '/projects';
export const onNew = () => routeName() === NEW_ROUTE || path() === '/projects/new';
export const onJoin = () => routeName() === JOIN_ROUTE || /^\/projects\/join\/[a-f0-9]+$/.test(path());
export const onFollow = () => routeName() === FOLLOW_ROUTE || /^\/projects\/(un)?follow\/[a-f0-9]+$/.test(path());
export const onPage = () => routeName() === PAGE_ROUTE || /^\/projects\/[a-z0-9-]+$/.test(path()) && !onNew();
export const onAnyProjects = () => onList() || onNew() || onJoin() || onFollow() || onPage();
/** /projects/{slug}?edit=1 shows the form for that project */
export const editing = () => onPage() && m.route.param('edit') === '1';

/** The forms' choices (cached for the visit) */
let meta = null;
let loading = false;
export function projectMeta() {
  if (!meta && !loading) {
    loading = true;
    app.request({
      method: 'GET',
      url: api('/projects-meta'),
      errorHandler: () => {}
    }).then(r => meta = r || {}).catch(() => meta = {}).then(() => m.redraw());
  }
  return meta;
}
export function go(url) {
  return ev => {
    if (ev && (ev.ctrlKey || ev.metaKey || ev.shiftKey)) return;
    if (ev) ev.preventDefault();
    m.route.set(url);
  };
}
const SYMBOL = {
  NGN: '₦',
  USD: '$',
  GBP: '£',
  EUR: '€',
  CAD: 'C$'
};
/** ₦1,250,000 / ₦1.25m */
export function money(v, currency, short) {
  const n = Number(v) || 0;
  const s = SYMBOL[currency] || (currency ? currency + ' ' : '₦');
  if (short && n >= 1e9) return s + (n / 1e9).toFixed(2).replace(/\.?0+$/, '') + 'bn';
  if (short && n >= 1e6) return s + (n / 1e6).toFixed(2).replace(/\.?0+$/, '') + 'm';
  return s + n.toLocaleString('en-US', {
    maximumFractionDigits: 2
  });
}
export const STATUS_TONE = {
  planning: '#b45309',
  active: '#2563eb',
  paused: '#6b7280',
  completed: '#1e8e3e',
  cancelled: '#c0392b'
};
export function dateText(d) {
  if (!d) return '';
  const [y, mo, day] = String(d).slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y, mo - 1, day)).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  });
}
export function placeText(p) {
  if (p.country && p.country !== 'NG') return [p.place, p.countryName || p.country].filter(Boolean).join(', ');
  return [p.location, p.lga && p.lga.name, p.state && p.state.name + ' State'].filter(Boolean).join(', ');
}

/** "Reference price", "My estimate", "Supplier quote" */
export const PRICE_LABEL = {
  reference: 'Reference price',
  estimated: 'My estimate',
  confirmed: 'Supplier quote'
};

/** A thin bar: progress or money raised */
export function bar(percent, color) {
  return m("span", {
    className: "VProj-bar",
    "aria-hidden": "true"
  }, m("i", {
    style: {
      width: Math.max(0, Math.min(100, percent || 0)) + '%',
      background: color || '#1b4540'
    }
  }));
}

/**
 * After "Post an update" on a project's page: the discussion the member posts next (within 30 minutes) becomes the
 * project's update. Called when a discussion page shows a discussion.
 */
export function linkNewProjectDiscussion(discussion) {
  let p = null;
  try {
    p = JSON.parse(sessionStorage.getItem('vprojPending') || 'null');
  } catch (e) {}
  if (!p) return;
  const me = app.session.user;
  const created = discussion.createdAt && discussion.createdAt();
  const clear = () => {
    try {
      sessionStorage.removeItem('vprojPending');
    } catch (e) {}
  };
  if (!me || Date.now() - p.at > 30 * 60e3) return clear();
  if (!discussion.user() || discussion.user() !== me || !created || created.getTime() < p.at - 60e3) return;
  clear();
  app.request({
    method: 'POST',
    url: api('/projects/' + p.id + '/discussions'),
    body: {
      discussionId: Number(discussion.id())
    },
    errorHandler: () => {}
  }).then(() => app.alerts.show({
    type: 'success'
  }, 'Posted as an update on ' + p.name + '.')).catch(() => {});
}
flarum.reg.add('voucha-community', 'forum/projects/util', { LIST_ROUTE: LIST_ROUTE,NEW_ROUTE: NEW_ROUTE,JOIN_ROUTE: JOIN_ROUTE,FOLLOW_ROUTE: FOLLOW_ROUTE,PAGE_ROUTE: PAGE_ROUTE,communityOpen: communityOpen,api: api,onList: onList,onNew: onNew,onJoin: onJoin,onFollow: onFollow,onPage: onPage,onAnyProjects: onAnyProjects,editing: editing,projectMeta: projectMeta,go: go,money: money,STATUS_TONE: STATUS_TONE,dateText: dateText,placeText: placeText,PRICE_LABEL: PRICE_LABEL,bar: bar,linkNewProjectDiscussion: linkNewProjectDiscussion, });